import { 
  GET_SYNDI_CLICKS_DASHBOARD_STICKY_COLUMNS, 
  GET_SYNDI_CLICKS_DASHBOARD_STICKY_COLUMNS_ERROR, 
  GET_SYNDI_CLICKS_DASHBOARD_STICKY_COLUMNS_SUCCESS, 
  UPDATE_SYNDI_CLICKS_DASHBOARD_STICKY_COLUMNS, 
  UPDATE_SYNDI_CLICKS_DASHBOARD_STICKY_COLUMNS_ERROR,
  UPDATE_SYNDI_CLICKS_DASHBOARD_STICKY_COLUMNS_SUCCESS 
} from "./actionTypes"

export const getSyndiClicksDashboardStickyColumns = () => {
  return {
    type: GET_SYNDI_CLICKS_DASHBOARD_STICKY_COLUMNS,
  }
}

export const getSyndiClicksDashboardStickyColumnsSuccess = sticky_columns => {
  return {
    type: GET_SYNDI_CLICKS_DASHBOARD_STICKY_COLUMNS_SUCCESS,
    payload: sticky_columns,
  }
}

export const getSyndiClicksDashboardStickyColumnsError = error => {
  return {
    type: GET_SYNDI_CLICKS_DASHBOARD_STICKY_COLUMNS_ERROR,
    payload: error,
  }
}

export const updateSyndiClicksDashboardStickyColumns = (sticky_columns) => {
  return {
    type: UPDATE_SYNDI_CLICKS_DASHBOARD_STICKY_COLUMNS,
    payload: sticky_columns,
  }
}

export const updateSyndiClicksDashboardStickyColumnsSuccess = sticky_columns => {
  return {
    type: UPDATE_SYNDI_CLICKS_DASHBOARD_STICKY_COLUMNS_SUCCESS,
    payload: sticky_columns,
  }
}

export const updateSyndiClicksDashboardStickyColumnsError = error => {
  return {
    type: UPDATE_SYNDI_CLICKS_DASHBOARD_STICKY_COLUMNS_ERROR,
    payload: error,
  }
}